export interface ITicketLogItem  {
    ID: number;
    TicketID: number;
    DateTimeCreated: Date;
    Action: string;

}



export class TicketLogItemArray extends Array<TicketLogItem>  {

        constructor(...items: TicketLogItem[]) {
            super(...items);
            Object.setPrototypeOf(this, TicketLogItemArray.prototype);
        }

    }

export class TicketLogItem implements ITicketLogItem {
    ID: number;
    TicketID: number;
    DateTimeCreated: Date;
    Action: string;

}
